import teamConfig from "../../../utils/constants/teams";
import { scoreCardTranslationMap } from "../../../utils/translations";

const { salesManager } = teamConfig.teams;

export const drawerItemsMain = (usersTeam: string, isAdminOrOwner: boolean, isMobileDevice: boolean = false) => [
  {
    key: "Stocks",
    title: "stock",
    routes: [{ nav: "Stocks", routeName: "Stocks", title: "stock" }],
  },
  {
    key: "Products",
    title: "searchProduct",
    routes: [{ nav: "Products", routeName: "Products", title: "product" }],
  },
  {
    key: "CustomerStatus",
    title: "customerStatus",
    routes: [
      {
        nav: "CustomerStatus",
        routeName: "CustomerStatus",
        title: "customerStatus",
      },
    ],
  },
  // {
  //   key: "CustomerOrder",
  //   title: "Customer Order",
  //   routes: [{ nav: "CustomerOder", routeName: "CustomerOrder", title: "Customer Order" }],
  // },
  ...((usersTeam === salesManager || isAdminOrOwner) && !isMobileDevice
    ? [
        {
          key: "SalesScorecard",
          title: "Sales Scorecard",
          routes: [
            { nav: "SalesScorecard",      routeName: "SalesScorecard",      title: scoreCardTranslationMap["Dashboard"] },
            { nav: "UsageSalesScorecard", routeName: "UsageSalesScorecard", title: scoreCardTranslationMap["Usage"] },
            { nav: "ValueSalesScorecard", routeName: "ValueSalesScorecard", title: scoreCardTranslationMap["Value"] },
            { nav: "InvoiceDNDetail",     routeName: "InvoiceDNDetail",     title: scoreCardTranslationMap["InvoiceDN"] },
          ],
        },
      ]
    : []),
];
